import {addBranchUrl, getCompanyDataUrl, getCustomerDataUrl, singleBranchUrl, updateBranchUrl} from "../api";
import {customAxios as axios, getToken} from "../../../request";
import {hideLoader, showLoader} from "../../../actions/loader";
import {notification} from "../../../components/Elements/appUtils";
export const fetchCompany = async (valData) => {
    let config = {
        params: {...valData}
    }
    const {data} = await axios.get(getCompanyDataUrl(), config);
    return data;
};

export const fetchCustomer = async (valData) => {
    let config = {
        params: {...valData},
        ...await getToken()
    }
    const {data} = await axios.get(getCustomerDataUrl(), config);
    return data;
};

export const addBranchFxn = (valData) => async (dispatch) => {
    dispatch(showLoader())
    const {data} = await axios.post(addBranchUrl(), valData, getToken());
    dispatch(hideLoader())
    if (!data.error) {
        notification.success({message: data.message || "Success"})
    } else {
        notification.error({message: data.message || "Error"})
    }
    return data;
};
export const singleBranchFxn = (id) => async (dispatch) => {
    dispatch(showLoader());
    
    let { data } = await axios.get(singleBranchUrl(id));
    console.log(data);
    dispatch(hideLoader());
    if (data.error) {
      notification.error({
        message: data.message || "Error",
      });
    }
  
    return data;
  };
  export const updateBranchFxn = (valData) => async (dispatch) => {
    dispatch(showLoader());
    let {data} = await axios.post(updateBranchUrl(), valData ,getToken());
    dispatch(hideLoader());
    if (data.error) {
        notification.error({
            message: data.message || "Error",
        });
    } else {
        notification.success({
            message: data.message || "Success",
        });
    }
    return data;
  };

